import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Field from 'components/Field';
import { debounce } from 'lodash';

class SearchField extends Component {
  state = {
    filterQuery: '',
  };
  startSearchRequest = debounce(
    () => {
      const { filterQuery } = this.state;
      this.props.onChange(filterQuery);
    },
    300,
    { leading: true },
  );

  getIcon = () => {
    const { filterQuery } = this.state;
    const canClear = filterQuery.length >= 1;

    return canClear ? (
      <span className="icon_reset search_icons" onClick={this.clearSearchRequest} />
    ) : (
      <span className="icon_search search_icons" onClick={this.startSearchRequest} />
    );
  };

  clearSearchRequest = () => {
    this.setState({ filterQuery: '' }, this.startSearchRequest);
  };

  handleChange = (e) => {
    e.preventDefault();

    const filterQuery = e.target.value;

    this.setState(
      {
        filterQuery,
        showAutocomplete: true,
      },
      this.startSearchRequest,
    );
  };

  render() {
    const placeholder = this.props.placeholder
      ? this.props.placeholder
      : 'Введите наименование для поиска';

    return (
      <div>
        <Field
          placeholder={placeholder}
          onChange={this.handleChange}
          maxLength={256}
          hasHelpWrap={false}
          onFocus={this.showAutoComplete}
          value={this.state.filterQuery}
          className={cn(['form_item', this.props.className])}
        >
          {this.getIcon()}
        </Field>
      </div>
    );
  }
}

SearchField.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

export default SearchField;
